import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import {Stack} from "@mui/material";

import {useDispatch} from "react-redux";

import {changeWorkIssuance} from "../workIssuanceSlice";
import {changeWork} from "../../Work/workSlice";



export default function WorkIssuancePayTabs(props) {
    const [workIssuanceTabValue, setWorkIssuanceTabValue] = React.useState(3);

    const dispatchData = useDispatch();


    const handleChange = (event, newValue) => {
        setWorkIssuanceTabValue(newValue);

        if(newValue == 0){
            dispatchData(changeWorkIssuance({owedGridState: false,obligationGridState: false,offsetsGridState: false,paymentGridState: false,fringeGridState: true,taxGridState: false,expenseGridState: false, requestGridState: false, confirmationGridState: false,
                clearData: true, fetchProductId: 0}));
            dispatchData(changeWork({propertyId: 0}));
            console.log("open fringe");
        }
        if(newValue == 1){
            dispatchData(changeWorkIssuance({owedGridState: false,obligationGridState: false,offsetsGridState: false,paymentGridState: true,fringeGridState: false,taxGridState: false,expenseGridState: false, requestGridState: false, confirmationGridState: false,
                clearData: true, fetchProductId: 0}));
            dispatchData(changeWork({propertyId: 0}));
            console.log("open payment");
        }
        if(newValue ==2){
            dispatchData(changeWorkIssuance({owedGridState: false,obligationGridState: false,offsetsGridState: false,paymentGridState: false,fringeGridState: false,taxGridState: true,expenseGridState: false, requestGridState: false, confirmationGridState: false,
                clearData: true, fetchProductId: 0}));
            dispatchData(changeWork({propertyId: 0}));
            console.log("open tax");
        }
        if(newValue == 3){
            dispatchData(changeWorkIssuance({owedGridState: false, obligationGridState: false,offsetsGridState: false,paymentGridState: false,fringeGridState: false,taxGridState: false,expenseGridState: true, requestGridState: false, confirmationGridState: false,
                clearData: true, fetchProductId: 0}));
            dispatchData(changeWork({propertyId: 0}));
            console.log("open expense");
        }

    };

    return (
        <Stack direction="row" spacing={2}>

            <Box sx={{pt: 2,   height: 40, bgcolor: 'background.paper' }}>
                <Tabs value={workIssuanceTabValue} defaultValue={3}
                      onChange={handleChange} >
                    <Tab label="Fringe"    title="Fringe amounts owed (pension, health plan, etc.)"
                         sx={{
                             mx: 4,
                             fontSize: '1.2rem',
                             fontWeight: 500,
                             // textTransform: 'none'   // optional: prevents ALL CAPS
                         }}/>
                    <Tab label="Payment"    title="Payment amounts and related data"
                         sx={{
                             mx: 4,
                             fontSize: '1.2rem',
                             fontWeight: 500,
                             // textTransform: 'none'   // optional: prevents ALL CAPS
                         }}/>
                    <Tab  label="Tax"   title="Estimated employer taxes"
                          sx={{
                              mx: 4,
                              fontSize: '1.2rem',
                              fontWeight: 500,
                              // textTransform: 'none'   // optional: prevents ALL CAPS
                          }}/>
                    <Tab label="Expense"     title="Total expenses including payments, fringe and taxes"
                         sx={{
                             mx: 4,
                             fontSize: '1.2rem',
                             fontWeight: 500,
                             // textTransform: 'none'   // optional: prevents ALL CAPS
                         }}/>
                </Tabs>
            </Box>
        </Stack>
    );
}
